export const HOME_API_DEFAULT_PAGE = 1;
export const HOME_API_DEFAULT_PAGE_SIZE = 100;

export const HOME_API_PATHS = {
    runs: 'api/v1/runs',
    refineries: 'api/v1/refineries',
    approvals: 'approvals',
    citationsManifest: 'citations/manifest',
    summary: 'summary',
    assets: 'assets',
    regeneratePdf: 'regenerate-pdf',
    pdfStatus: 'pdf-status',
    processSummary: 'process-summary',
    processSummaryPdf: 'process-summary/pdf/generated',
    mentions: 'mentions',
    edits: 'edits'
} as const;
